<div class="input-group input-group-sm">
    <kendo-datepicker *ngIf="!withTime" [value]="dateValue.value" (valueChange)="dateValueCorrection($event);"
        [spv2DateInputResetButton]="withResetButton" kendoTooltip showOn="none" (mouseover)="showTooltip($event)"
        [tooltipTemplate]="template">
        <ng-template kendoCalendarHeaderTitleTemplate let-title>
            <div class="text-left">
                <div *ngIf="withAfterBeforeChoice" class="mt-2" (click)="stopPropagation($event)">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                            [value]="'ge'" [(ngModel)]="dateValue.condition" (ngModelChange)="startDebounce()">
                        <label class="form-check-label" for="inlineRadio2">After</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                            [value]="'le'" [(ngModel)]="dateValue.condition" (ngModelChange)="startDebounce()">
                        <label class="form-check-label" for="inlineRadio1">Before</label>
                    </div>
                </div>
                {{title}}
            </div>
        </ng-template>
    </kendo-datepicker>

    <kendo-datetimepicker *ngIf="withTime" [(value)]="dateValue.value" (valueChange)="startDebounce();" kendoTooltip
        showOn="none" (mouseover)="showTooltip($event)" [tooltipTemplate]="template">
        <ng-template kendoCalendarHeaderTitleTemplate let-title>
            <div class="text-left">
                <div *ngIf="withAfterBeforeChoice" class="mt-2" (click)="stopPropagation($event)">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                            [value]="'ge'" [(ngModel)]="dateValue.condition" (ngModelChange)="startDebounce()">
                        <label class="form-check-label" for="inlineRadio2">After</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                            [value]="'le'" [(ngModel)]="dateValue.condition" (ngModelChange)="startDebounce()">
                        <label class="form-check-label" for="inlineRadio1">Before</label>
                    </div>
                </div>
                {{title}}
            </div>
        </ng-template>
    </kendo-datetimepicker>
</div>

<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.value }}</span>
</ng-template>